import { createAction, props } from '@ngrx/store';
import { IPrivacySettings } from '../models/privacy-settings.model';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';

export const loadPrivacySettings = createAction('[PrivacySettings] Load PrivacySettings', props<{ request: string }>());

export const loadPrivacySettingssSuccess = createAction(
  '[PrivacySettings] Load PrivacySettings Success',
  props<{ response: IPrivacySettings }>()
);

export const loadPrivacySettingssFailure = createAction(
  '[PrivacySettings] Load PrivacySettings Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
